import { createAsyncThunk } from '@reduxjs/toolkit'
import { SOMETHING_WHEN_WRONG } from 'constant/errorMessages'
import { ReplenishmentV3ItemsQueryType } from 'features/SupplyOrder/@types/ReplenishmentV3'
import {
  getReplenishmentTaskV3Detail,
  getReplenishmentTaskV3Items,
} from 'features/SupplyOrder/services/replenishmentV3'
import { callErrorMsg } from 'helpers/errorMsg'

export const SLICE_NAME = 'REPLENISHMENT_LETDOWN_DETAIL'

export const fetchGetReplenishmentLetdownTaskDetail = createAsyncThunk(
  `${SLICE_NAME}/fetchGetReplenishmentLetdownTaskDetail`,
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getReplenishmentTaskV3Detail(id)

      return response.data.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchGetReplenishmentLetdownTaskItems = createAsyncThunk(
  `${SLICE_NAME}/fetchGetReplenishmentLetdownTaskItems`,
  async (
    { id, params }: { id: number; params: ReplenishmentV3ItemsQueryType },
    { rejectWithValue },
  ) => {
    try {
      const response = await getReplenishmentTaskV3Items(id, params)

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)
